import { render } from "./forum.vue?vue&type=template&id=55cf9910&scoped=true"
import script from "./forum.vue?vue&type=script&lang=js"
export * from "./forum.vue?vue&type=script&lang=js"

import "./forum.vue?vue&type=style&index=0&id=55cf9910&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55cf9910"]])

export default __exports__